import React, { useState } from "react";
import { ChevronDown, ChevronRight } from "lucide-react";

const faqs = [
  { question: "What is the age limit for UPSC?", answer: "21 to 32 years (with relaxation for reserved categories)." },
  { question: "How many attempts are allowed?", answer: "General: 6, OBC: 9, SC/ST: Unlimited (till age limit)." },
  { question: "Is UPSC tough to crack?", answer: "It’s challenging but possible with consistent preparation, smart strategy, and practice." },
  { question: "Can I prepare without coaching?", answer: "Yes, with self-study, online resources, and disciplined planning, many candidates clear without coaching." },
];

export default function Faq() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq" className="w-full bg-gray-50 py-12 px-6">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-bold text-indigo-900 text-center mb-8">
          FAQs
        </h2>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between p-4 text-left focus:outline-none"
                onClick={() => toggleFAQ(index)}
              >
                <span className="font-semibold text-red-700">
                  {faq.question}
                </span>
                {openIndex === index ? (
                  <ChevronDown className="w-5 h-5 text-gray-600" />
                ) : (
                  <ChevronRight className="w-5 h-5 text-gray-600" />
                )}
              </button>
              {openIndex === index && (
                <div className="px-4 pb-4 text-gray-700 text-sm border-t border-gray-100 animate-fadeIn">
                  {faq.answer}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
